import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ViewAllIntegrationLayer from '../components/ViewAllIntegrationLayer';

export const ViewAllIntegrationPage = () => {
    return (
        <>
        {/* Master layout*/}
        <MasterLayout>
            {/* BreadCrum */}
            <Breadcrumb title='All Integrations'/>

            {/* ViewAllIntegrationLayer */}
            <ViewAllIntegrationLayer/>
        </MasterLayout>
        </>
    )
}